import { render, staticRenderFns } from "./EditHouseshop.vue?vue&type=template&id=bb460ba8&scoped=true"
import script from "./EditHouseshop.vue?vue&type=script&lang=js"
export * from "./EditHouseshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb460ba8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb460ba8')) {
      api.createRecord('bb460ba8', component.options)
    } else {
      api.reload('bb460ba8', component.options)
    }
    module.hot.accept("./EditHouseshop.vue?vue&type=template&id=bb460ba8&scoped=true", function () {
      api.rerender('bb460ba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/company/houseShop/EditHouseshop.vue"
export default component.exports